// extracted by mini-css-extract-plugin
var _1 = "OwnerToast-module_button__YkBHm";
var _2 = "OwnerToast-module_content__kO88E";
var _3 = "OwnerToast-module_text__F3CBm";
export { _1 as "button", _2 as "content", _3 as "text" }
export default { "button": _1, "content": _2, "text": _3 }
